// src/layouts/corui/BackLayout.jsx
import React from "react"
import CoreUIStyles from "../../CoreUIStyles";
import BackAppSidebar from "./core/BackAppSidebar";
import { BackAppHeader } from "./core";
import BackAppContent from "./core/BackAppContent";
import BackAppFooter from "./core/BackAppFooter";
import { useLocation } from "react-router-dom";
import FloatingBibleReader from "../../components/dashboard/FloatingBibleReader";

const BackLayout = () => {
    const location = useLocation();

    // Liste des routes où le FloatingBibleReader ne doit PAS s'afficher
    const hiddenRoutes = ["/dashboard/espace-priere"];

    const shouldShowBibleReader = !hiddenRoutes.includes(location.pathname);

    return (
        <div>
            <CoreUIStyles /> {/* 👈 Charge les styles CoreUI */}
            <BackAppSidebar />
            <div className="wrapper d-flex flex-column min-vh-100">
                <BackAppHeader />
                <div className="body flex-grow-1">
                    {/* 🌐 Lecture Biblique Globale */}
                    {shouldShowBibleReader && <FloatingBibleReader />}
                    <BackAppContent />
                </div>
                <BackAppFooter />
            </div>
        </div>
    );
};

export default BackLayout
